export const TIPO_MODULO_INTERVENCION = {
  MEDICO: 1,
  ARMERIA: 2,
  ACADEMIA: 3,
}

export const TIPO_MODULO_INTERVENCION_LABELS = {
  [TIPO_MODULO_INTERVENCION.MEDICO]: 'Médico',
  [TIPO_MODULO_INTERVENCION.ARMERIA]: 'Armería',
  [TIPO_MODULO_INTERVENCION.ACADEMIA]: 'Academia',
}
